module.exports = __webpack_public_path__ + "static/img/main.2208d917.png";